import * as React from 'react';
import type { SVGProps } from 'react';
const FileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="22"
    height="26"
    viewBox="0 0 22 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.375 15.8125V12.5312C20.375 11.4124 19.9305 10.3393 19.1394 9.54814C18.3482 8.75697 17.2751 8.3125 16.1562 8.3125H14.2812C13.9083 8.3125 13.5506 8.16434 13.2869 7.90062C13.0232 7.6369 12.875 7.27921 12.875 6.90625V5.03125C12.875 3.91237 12.4305 2.83931 11.6394 2.04814C10.8482 1.25697 9.77513 0.8125 8.65625 0.8125H6.3125M7.25 18.625V19.5625M11 15.8125V19.5625M14.75 13V19.5625M9.125 0.8125H3.03125C2.255 0.8125 1.625 1.4425 1.625 2.21875V23.7812C1.625 24.5575 2.255 25.1875 3.03125 25.1875H18.9688C19.745 25.1875 20.375 24.5575 20.375 23.7812V12.0625C20.375 9.07881 19.1897 6.21733 17.08 4.10755C14.9702 1.99776 12.1087 0.8125 9.125 0.8125Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default FileIcon;
